
export const GRID_NORMAL = {
    padding: {
        left: 15,
        right: 0,
        top: -10,
        bottom: -5
    }
}
export const GRID_SMALL = {
    padding: {
        left: 0,
        right: 0,
        top: -10,
        bottom: -15
    }
}
export const GRID_CITY = {
    padding: {
        left: 0,
        right: 0,
        top: -15,
        bottom: -15
    }
}

export const GRID_RANK = {
    show: true, // 罫線
    xaxis: {
        lines: {
            show: false, // ← 全ての縦線（X方向）を消す
        }
    },
    yaxis: {
        lines: {
            show: false, // ← 全ての横線（Y方向）を消す
        }
    },
    padding: {
        left: 0,
        right: 0,
        top: -15,
        bottom: -15
    }
}

export const GRID_RANK_RIGHT2 = {
    padding: {
        left: 0,
        right: 2,
        top: -25,
        bottom: -15
    }
}
